import React from 'react'
import { Card, Button, Container } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import Layout from '../components/Layout'

export default function NotFound() {
  const navigate = useNavigate()

  return (
    <Layout>
      <Container>
        <Card className="text-center shadow">
          <Card.Body className="py-5">
            <h1 className="display-1 text-muted">404</h1>
            <h2 className="mb-4">Page non trouvée</h2>
            <p className="text-muted mb-4">
              La page que vous recherchez n'existe pas ou a été déplacée..
            </p>
            <Button 
              variant="primary" 
              onClick={() => navigate('/')}
              size="lg"
            >
              Retour à l'accueil
            </Button>
          </Card.Body>
        </Card>
      </Container>
    </Layout>
  )
}